import BackboneHolderView from './backbone_holder_view';

export default BackboneHolderView;
